/**
 *
 * Asynchronously loads the component for Coupon
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
